import React, { memo } from "react";
import {
  DndContext,
  closestCenter,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import { SortableProductItem } from "./SortableProductItem";

export const SortableProductList = memo(function SortableProductList({
  items,
  setItems,
  listings,
  settings,
  changeNote,
  toggleListingHideUrl,
}) {
  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(TouchSensor, {
      activationConstraint: { delay: 300, tolerance: 10 },
    })
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        <div className="sortable-products-list" id="listings-manage">
          <div className="list-container">
            {items.map((id) => {
              const listing = listings[id];
              // An id can outlive its listing: the saved `data.listings` order
              // is just ids, and the matching object is absent whenever the
              // listing was deleted upstream (the hydrate request 404s — see
              // the "This item no longer exists" toast in contexts/User.jsx).
              // `SortableProductItem` dereferences `listing.product`, so
              // rendering one of these orphans throws and takes the WHOLE list
              // down — which is why PRODUCT SELECTION rendered its toolbar and
              // then nothing else.
              if (!listing) return null;
              if (listing.status === "deleted") return null;
              return (
                <SortableProductItem
                  key={id}
                  id={id}
                  listing={listing}
                  settings={settings}
                  changeNote={changeNote}
                  toggleListingHideUrl={toggleListingHideUrl}
                />
              );
            })}
          </div>
        </div>
      </SortableContext>
    </DndContext>
  );

  function handleDragEnd(event) {
    const { active, over } = event;

    if (active.id !== over.id) {
      setItems((items) => {
        const oldIndex = items.indexOf(active.id);
        const newIndex = items.indexOf(over.id);

        return arrayMove(items, oldIndex, newIndex);
      });
    }
  }
});
